import React, { useContext, useState } from "react";
import ReactPasswordChecklist from "react-password-checklist";
import { NavLink, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const navigate = useNavigate()
  const [show, setShow] = useState(false);
  const [inputs,setInputs] = useState({
    email:"",
    password:""
  })
  const handleChange =(e)=>{
    const {name,value} = e.target
    setInputs((prevState)=>({
      ...prevState,
       [name]:value
    }))
  }
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errMessage, setErrMessage] = useState("");

  
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("email", inputs.email);
    formData.append("password",inputs.password);
    if (inputs.email == "" || inputs.password == "") {
      setErrMessage("E-poçt və yaxud şifrə boş buraxıla bilməz");
      return;
    }
    axios
      .post("https://turanozbahceci.com/api/login.php", {
        email: inputs.email,
        password: inputs.password,
      })
      .then((res) => {
        const jwtToken = jwtDecode(res.data.jwt);
        const name_jwt = jwtToken
        localStorage.setItem("name", name_jwt.data.firstName);
        localStorage.setItem("lastName", name_jwt.data.lastName);
        setErrMessage("");
        // bu olmasa avtomatik yenilenmir 
        window.dispatchEvent(new Event("storage"));
        localStorage.setItem("jwt",res.data.jwt)
        navigate(name_jwt.data.subscription == "2" ? "/admin" : "/dashboard")
        
        window.location.reload()
        setTimeout(() => {
          localStorage.removeItem("jwt");
          localStorage.removeItem("name");
          localStorage.removeItem("lastName");
          window.dispatchEvent(new Event("storage"));
        }, 3600000);
      
      })
      .catch((err) => {
        setErrMessage("E-poçt və yaxud şifrə yanlışdır");
      });
  };

  return (
    <>
      <div className="mt-5">
        <div className="login-register-section section section-padding-bottom">
          <div className="container">
            <div className="row ">
              <div className="col-12">
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-6">
                    {/* Login Form Start */}
                    <div className="login-form-wrapper">
                      <h3 className="title text-center">{t.signin}</h3>
                      <form
                        className="login-form"
                        action="#"
                        onSubmit={handleSubmit}
                      >
                        <div className="single-input mb-30">
                          <p className="text-center text-danger">
                            {errMessage}
                          </p>

                          <label htmlFor="username">{t.email}</label>
                          <input
                            type="text"
                            id="username"
                            name="email"
                            placeholder={t.email}
                            value={inputs.email}
                            onChange={handleChange}
                          />
                          {/* <p className="text-danger">
                            İstifadəçi adı və yaxud e-poçt yanlışdır.
                          </p> */}
                        </div>
                        <div className="single-input  passDiv">
                          <label htmlFor="password">{t.pass}</label>
                          <input
                            type={`${show ? "text" : "password"}`}
                            id="password"
                            name="password"
                            placeholder={t.pass}
                            className="passInput"
                            value={inputs.password}
                            onChange={handleChange}
                          />
                          <div onClick={() => setShow(!show)}>
                            <i
                              className={`fa-solid fa-eye${
                                show ? "-slash" : ""
                              }`}
                            ></i>
                          </div>
                        </div>
                        <div className="single-input mb-30">
                          <div className="row">
                            <div className="col-sm-6 remember-me-wrap">
                              <div className="checkbox-input mt-4">
                                <input
                                  type="checkbox"
                                  name="login-form-remember"
                                  id="login-form-remember"
                                  style={{ cursor: "pointer" }}
                                />
                                <label
                                  htmlFor="login-form-remember"
                                  style={{ cursor: "pointer" }}
                                >
                                  {t.check}
                                </label>
                              </div>
                            </div>
                            {/* <div className="col-sm-6 lost-your-password-wrap">
                              <p>
                                <a href="#" className="lost-your-password">
                                  Lost your password?
                                </a>
                              </p>
                            </div> */}
                          </div>
                        </div>
                        <div className="single-input">
                          <button
                            type="submit"
                            className="btn btn-primary btn-hover-secondary btn-width-100"
                          >
                            {t.signin}
                          </button>
                          <p className="text-center mt-4">
                            {t.newprofil}
                            <br />
                            <NavLink
                              to="/signup"
                              className="btn btn-primary mt-3"
                            >
                              {t.createnewprofile}
                            </NavLink>
                          </p>
                        </div>
                      </form>
                    </div>
                    {/* Login Form End */}
                  </div>
                  {/* <div className="col-xl-6  col-lg-6">
                    <div className="login-form-wrapper mt-sm-50 mt-xs-50">
                      <h3 className="title">Register</h3>
                      <form className="register-form" action="#">
                        <div className="single-input mb-30">
                          <label htmlFor="usernameOne">Username</label>
                          <input
                            type="text"
                            id="usernameOne"
                            name="username"
                            placeholder="Username"
                          />
                        </div>
                        <div className="single-input mb-30">
                          <label htmlFor="email">Email</label>
                          <input
                            type="text"
                            id="email"
                            name="username"
                            placeholder="Email"
                          />
                        </div>
                        <div className="single-input mb-30">
                          <label htmlFor="passwordOne">Password</label>
                          <input
                            type="text"
                            id="passwordOne"
                            name="password"
                            placeholder="Password"
                          />
                          <p className="description">
                            The password must be at least twelve characters
                            long, contain upper and lower case letters, contain
                            numbers, contain symbols like ! " ? $ % ^ &amp; ).
                          </p>
                        </div>
                        <div className="single-input">
                          <button className="btn btn-primary btn-hover-secondary btn-width-100">
                            Register
                          </button>
                        </div>
                      </form>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
